// Recycler fleet: truck positions and route runs.

import { defineRoutes } from '../core';
import { routeRunsForDay, truckTracking } from '../data/fleet';
import { str } from './errors';

export const fleetRoutes = defineRoutes([
  ['get', '/truck/tracking', (ctx) => ({ result: truckTracking(str(ctx.query.organization_id) ?? ctx.orgId) })],
  [
    'get',
    '/ops/route-runs',
    (ctx) => {
      const runs = routeRunsForDay(str(ctx.query.organization_id) ?? ctx.orgId, str(ctx.query.run_date));
      return { result: { runs, total: runs.length } };
    },
  ],
]);
